import {_getDocumentNodeIds} from './utils'

/**
 * Gets the first block node positioned after supplied node, or
 * the first block node in article if no reference node is supplied
 *
 * @param {EditorSession} editorSession
 * @param {Object} [refNode=null] - Node to use as reference
 *
 * @returns {Object|null} - Returns block node after refNode, first block node, or null
 */
function getNextBlockNode(editorSession, refNode = null) {
    const nodeIds = _getDocumentNodeIds(editorSession, 'body')
    const index = refNode ? nodeIds.indexOf(refNode.id) : 0

    for(let n = index; n < nodeIds.length; n++) {
        const node = editorSession.getDocument().get(nodeIds[n])

        if (node.ignorePosition !== true) {
            return node
        }
    }

    return null
}

export {getNextBlockNode}
